export const TipoAreaEnum = {
  RL: {
    id: 'RL',
    nome: 'Reserva legal',
    grupo: 38,
  },
  RL: {
    id: 'RL',
    nome: 'Reserva legal a Recompor',
    grupo: 38,
  },
  APP: {
    id: 'APP',
    nome: 'Área de preservação permanente',
    grupo: 8,
  },
  APP: {
    id: 'APP',
    nome: 'Área de preservação permanente a Recompor',
    grupo: 37,
  },
  AUR: {
    id: 'AUR',
    nome: 'Área de uso restrito',
    grupo: 10,
  },
}
